'use client';

import { LinkType } from '@ria-client/segment/enums';
import { EntityPlacementCtaTypeEnum } from '@ria-client/supergraph/marketplace/enums';
import type { MarketplaceEntityForProductCardType as MarketplaceEntity } from '@ria-client/supergraph/structuredContent/hydration/MarketplaceProductCard/types';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@ria-client/tw-shadcn/components/tabs';
import { ProsAndCons, ShowMore, TrackedLink } from '@ria-client/tw-shared-ui';

export interface MarketplaceProductCardTabsProps {
  marketplaceEntity: MarketplaceEntity;
}

export function MarketplaceProductCardTabs({ marketplaceEntity }: MarketplaceProductCardTabsProps) {
  const {
    consBullets,
    id,
    institution,
    monetizable,
    product,
    productType,
    prosBullets,
    reviewLink,
    tagline,
  } = marketplaceEntity;
  const analyticsPayload = {
    index: 0,
    institutionId: institution.id,
    offerId: id,
    productId: product.id,
    productType,
  };

  return (
    <Tabs className="mt-6" defaultValue="why-we-like-it">
      <TabsList>
        <TabsTrigger value="why-we-like-it">Why we like it</TabsTrigger>
        <TabsTrigger value="pros-and-cons">Pros &amp; Cons</TabsTrigger>
      </TabsList>
      <TabsContent className="pt-6" value="why-we-like-it">
        <ShowMore isDefaultExpanded={false}>
          <p className="typography-body">{tagline}</p>
        </ShowMore>
      </TabsContent>
      <TabsContent className="pt-6" value="pros-and-cons">
        <ProsAndCons consList={consBullets} prosList={prosBullets} />
        <TrackedLink
          analyticsPayload={analyticsPayload}
          cta={{
            link: reviewLink,
            showIcon: false,
            text: 'Read Full Review',
            type: EntityPlacementCtaTypeEnum.ReadReview,
          }}
          linkType={LinkType.OFFER_LINK}
          monetizable={monetizable}
        >
          Read Full Review
        </TrackedLink>
      </TabsContent>
    </Tabs>
  );
}
